import script from "./WordCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WordCard.vue?vue&type=script&setup=true&lang=js"

import "./WordCard.vue?vue&type=style&index=0&id=0fc5ef6a&lang=scss"

const __exports__ = script;

export default __exports__